import React, { useState } from 'react'
import { ActionBarItem } from './ControlPage'
import GavelIcon from '@mui/icons-material/Gavel'
import BigModal from '../../../../components/Modals/BigModal'
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import NotesIcon from '@mui/icons-material/Notes'
import API from '../../../../services/API'
import { FactCheck } from '@mui/icons-material'

const NewCommandLog = ({ roomID, linkedEventID }) => {
  const [openNewLog, setOpenNewLog] = useState(false)
  const [newLog, setNewLog] = useState('')
  const [isCommand, setIsCommand] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()

    API.post(`/controlroom/${roomID}/log`, {
      log: newLog,
      event: linkedEventID,
      controlRoom: roomID,
      type: isCommand ? 'Command' : 'Log',
    }).then((res) => {
      if (res.status === 200) {
        setOpenNewLog(false)
        setNewLog('')
        setIsCommand(false)
      }
    })
  }

  return (
    <>
      <ActionBarItem
        icon={<FactCheck />}
        color="#239AA4"
        text="New Log"
        onClick={() => setOpenNewLog(true)}
        flex={1}
      />

      <BigModal
        open={openNewLog}
        onClose={() => setOpenNewLog(false)}
        autoWidth
        style={{ width: { xs: '94vw', sm: 'auto' }, maxWidth: { xs: '94vw', sm: '90vw' } }}
      >
        <Box sx={{ width: '100%', maxWidth: 560 }}>
          <Box
            sx={{
              mx: -3,
              mt: -3,
              mb: 3,
              p: 3,
              color: 'white',
              background:
                'linear-gradient(135deg, #1A2230 0%, #242F40 55%, #239AA4 150%)',
            }}
          >
            <Stack direction="row" spacing={2} alignItems="center">
              <Box
                sx={{
                  width: 52,
                  height: 52,
                  borderRadius: 3,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(255,255,255,0.12)',
                  border: '1px solid rgba(255,255,255,0.22)',
                }}
              >
                <NotesIcon />
              </Box>

              <Stack>
                <Typography variant="overline" sx={{ opacity: 0.72 }}>
                  Control Room Log
                </Typography>
                <Typography variant="h5" fontWeight={900} color="white">
                  Add New Log
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ opacity: 0.78 }}
                  color="white"
                >
                  Record an operational note or command instruction.
                </Typography>
              </Stack>
            </Stack>
          </Box>

          <Stack gap={2.5} p={1} component="form" onSubmit={handleSubmit}>
            <TextField
              label={isCommand ? 'Command instruction' : 'Log entry'}
              value={newLog}
              onChange={(e) => setNewLog(e.target.value)}
              fullWidth
              multiline
              minRows={4}
              autoFocus
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1,
                },
              }}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={isCommand}
                  onChange={(e) => setIsCommand(e.target.checked)}
                />
              }
              label='Mark as a "Command" log'
            />

            <Divider />

            <Stack
              direction={{ xs: 'column-reverse', sm: 'row' }}
              spacing={1.5}
            >
              <Button
                fullWidth
                onClick={() => setOpenNewLog(false)}
                sx={{
                  borderRadius: 999,
                  textTransform: 'none',
                  fontWeight: 800,
                  color: '#64748B',
                }}
              >
                Cancel
              </Button>

              <Button
                disabled={!newLog.trim()}
                variant="contained"
                fullWidth
                type="submit"
                sx={{
                  borderRadius: 999,
                  textTransform: 'none',
                  fontWeight: 900,
                  backgroundColor: isCommand ? '#E32525' : '#239AA4',
                  '&:hover': {
                    backgroundColor: isCommand ? '#B91C1C' : '#1E7F88',
                  },
                }}
              >
                Submit {isCommand ? 'Command' : 'Log'}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </BigModal>
    </>
  )
}

export default NewCommandLog
